<template>
    <div class="user-picture" :class="[size, border]">
        <template v-if="!status">
            <div class="embed-item">
                <base-spinner />
            </div>
        </template>

        <template v-else>
            <img class="embed-item" v-if="user.image" :src="user.image" :alt="user.name" />
            <img class="embed-item" v-else :src="defaultImage" alt="no image" />
        </template>
    </div>
</template>

<script>
    import BaseSpinner from '@/Components/BaseSpinner'
    import defaultImage from '@/Assets/Images/no-user.png'

    export default {
        components: {
            BaseSpinner,
        },

        data() {
            return {}
        },

        props: {
            user: {
                type: Object,
                require: true,
                default() {
                    return {}
                },
            },

            border: {
                required: false,
                type: String,
                default: '-border-light',
            },

            size: {
                required: false,
                type: String,
                default: '',
            },
        },

        computed: {
            status() {
                return this.user ? true : false
            },

            defaultImage() {
                return defaultImage ? defaultImage : ''
            },
        },
    }
</script>

<style lang="stylus"></style>
